"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBulletinsGraphQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
const meetingBulletinAppeals_1 = __importDefault(require("./queries/meetingBulletinAppeals"));
const deleteBulletin_1 = __importDefault(require("./mutations/deleteBulletin"));
const meetingVotingHistory_1 = __importDefault(require("./queries/meetingVotingHistory"));
class MeetingBulletinsGraphQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.queryBulletinsList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinsList, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.list;
    });
    this.queryBulletinsResultList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinsResultList, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.resultList;
    });
    this.queryBulletinsFooterStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinsFooterStatistics, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.footerStatistic;
    });
    this.queryBulletinsFilters = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinsFilters, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.filters;
    });
    this.queryUnrecognizedDocumentsFilters = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingUnrecognizedDocumentFilters, variables, options, requestOptions);
      return response.data.meetings.meeting.unrecognizedFiles.filters;
    });
    this.queryUnrecognizedDocumentsList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingUnrecognizedDocumentsList, variables, options, requestOptions);
      return response.data.meetings.meeting.unrecognizedFiles.list;
    });
    this.queryResultFilters = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingResultFilters, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.resultFilters;
    });
    this.queryBulletinRegistrationData = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinRegistrationData, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletin.registrationData;
    });
    this.bulletinsRegistration = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.meetingBulletinsRegistration, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.registration;
    });
    this.sendMeetingBulletinsToMail = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendMeetingBulletinsToMail, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.sendToEmail;
    });
    this.getBulletinHistory = (variables, options = {}, requestOtions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletingHistory, variables, options, requestOtions);
      return response.data.meetings.meeting.bulletin.history;
    });
    this.getMeetingVotingHistory = (variables, options = {}, requestOtions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(meetingVotingHistory_1.default, variables, options, requestOtions);
      return response.data.meetings.meeting.voting.history;
    });
    this.getBulletinFilesSingle = (variables, options = {}, requestOtions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingBulletinSingleFile, variables, options, requestOtions);
      return response.data.meetings.meeting.bulletin.files.single;
    });
    this.getUnrecognizedFilesHistory = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.unrecognizedFilesHistory, variables, options, requestOptions);
      return response.data.meetings.meeting.unrecognizedFiles.history;
    });
    this.sendBulletinHistoryComment = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.bulletingHistoryComment, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.makeComment;
    });
    this.downloadBulletin = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.downloadMyBulletin, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.sendPapers;
    });
    this.getBulletinAppeals = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(meetingBulletinAppeals_1.default, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletin.appeals;
    });
    this.deleteBulletin = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(deleteBulletin_1.default, variables, options, requestOptions);
      return response.data.meetings.meeting.bulletins.deletePaperBulletin;
    });
    this.getPdfScanCopyOfBulletin = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingPdfScanCopy, variables, options, requestOptions);
      return response.data.meetings.meeting.voting.scanCopyPdf;
    });
    this.getBulletinPdfOfBulletin = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meetingGetBulletinPdf, variables, options, requestOptions);
      return response.data.meetings.meeting.voting.bulletinPdf;
    });
  }
}
exports.MeetingBulletinsGraphQLService = MeetingBulletinsGraphQLService;
const meetingBulletinsGraphQLService = new MeetingBulletinsGraphQLService();
exports.default = meetingBulletinsGraphQLService;